/** @flow */
import * as actions from "@modules/service/constants/actions";
import * as shiftPatternsReducers from "./reducers";
import initialState from "./state";
import type { ShiftPatternsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ShiftPatternsState = initialState, action: Object): Object => {
  const act = {
    [actions.UpdateShiftPattern]: shiftPatternsReducers.onUpdateShiftPattern,
    [actions.UpdateShiftPatternSuccess]: shiftPatternsReducers.onUpdateShiftPatternSuccess,
    [actions.UpdateShiftPatternError]: shiftPatternsReducers.onUpdateShiftPatternError,

    [actions.GetShiftPatterns]: shiftPatternsReducers.onGetShiftPatterns,
    [actions.GetShiftPatternsSuccess]: shiftPatternsReducers.onGetShiftPatternsSuccess,
    [actions.GetShiftPatternsError]: shiftPatternsReducers.onGetShiftPatternsError,

    [actions.GetTotalShiftPatterns]: shiftPatternsReducers.onGetTotalShiftPatterns,
    [actions.GetTotalShiftPatternsSuccess]: shiftPatternsReducers.onGetTotalShiftPatternsSuccess,
    [actions.GetTotalShiftPatternsError]: shiftPatternsReducers.onGetTotalShiftPatternsError,

    [actions.NewShiftPattern]: shiftPatternsReducers.onNewShiftPattern,
    [actions.SetShiftPattern]: shiftPatternsReducers.onSetShiftPattern,

    [actions.ShowAddShiftPatternModal]: shiftPatternsReducers.onSetShowAddModal,
    [actions.ShowEditShiftPatternModal]: shiftPatternsReducers.onSetShowEditModal,
    [actions.ShowDeleteShiftPatternModal]: shiftPatternsReducers.onSetShowDeleteModal,
    [actions.ToggleUnassignReassignShiftPatternModal]:
      shiftPatternsReducers.onUnassignReassignShiftPatternModal,
    [actions.ToggleUnassignReassignItemsToShiftPatternModal]:
      shiftPatternsReducers.onToggleUnassignReassignItemsToShiftPatternModal,
    [actions.GetEmployeePositionsAssignedToShiftPattern]:
      shiftPatternsReducers.onGetEmployeePositionsAssignedToShiftPattern,
    [actions.GetEmployeePositionsAssignedToShiftPatternSuccess]:
      shiftPatternsReducers.onGetEmployeePositionsAssignedToShiftPatternSuccess,
    [actions.GetEmployeePositionsAssignedToShiftPatternError]:
      shiftPatternsReducers.onGetEmployeePositionsAssignedToShiftPatternError,
    [actions.GetDepartmentsAssignedToShiftPattern]:
      shiftPatternsReducers.onGetDepartmentsAssignedToShiftPattern,
    [actions.GetDepartmentsAssignedToShiftPatternSuccess]:
      shiftPatternsReducers.onGetDepartmentsAssignedToShiftPatternSuccess,
    [actions.GetDepartmentsAssignedToShiftPatternError]:
      shiftPatternsReducers.onGetDepartmentsAssignedToShiftPatternError,
    [actions.UpdateShiftPatternDraft]: shiftPatternsReducers.onUpdateShiftPatternDraft,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
